/** Chemin Puck `setDeep` pour un champ dans un tableau (ex. `slides[0].subtitle`). */
export function puckArrayFieldPath(arrayKey, index, field) {
  return `${arrayKey}[${index}].${field}`;
}

/**
 * Chemin d'un champ dans un tableau imbriqué dans un tableau
 * (ex. `rows[0].cells[1].value`) — le cas d'une cellule de tableau.
 */
export function puckNestedArrayFieldPath(arrayKey, index, nestedKey, nestedIndex, field) {
  return `${puckArrayFieldPath(arrayKey, index, nestedKey)}[${nestedIndex}].${field}`;
}

/** `a[0].b[1].c` → ['a', '0', 'b', '1', 'c'] — même découpage que `setDeep`. */
function pathSegments(contentPath) {
  return String(contentPath)
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .filter((segment) => segment !== '');
}

/** Lit une prop simple ou imbriquée (`cards[2].description`, `rows[0].cells[1].value`). */
export function getPropAtPath(props, contentProp, contentPath) {
  if (!props) return undefined;
  if (contentPath) {
    return pathSegments(contentPath)
      .reduce((acc, key) => (acc == null ? acc : acc[key]), props);
  }
  return props[contentProp];
}
